import { render, staticRenderFns } from "./SettingsStageSwissCalculatorHelper.vue?vue&type=template&id=95dfae9c&"
import script from "./SettingsStageSwissCalculatorHelper.vue?vue&type=script&lang=js&"
export * from "./SettingsStageSwissCalculatorHelper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports